import HeroContainer from "../../containers/HeroContainer.tsx";
import GuidedTour from "../GuidedTour.tsx";

const GuidedTourPage = () => (
  <HeroContainer headerContent={<GuidedTour />} bodyContent={null} />
);

export default GuidedTourPage;
